
import { useState } from 'react';

interface Procedure {
  id: string;
  title: string;
  icon: string;
  description: string;
  features: string[];
  benefits: string[];
  image: string;
}

const procedures: Procedure[] = [
  {
    id: 'cirugia-laser-prostata',
    title: 'Cirugía Láser de Próstata',
    icon: 'ri-flashlight-line',
    description: 'Tratamiento avanzado con tecnología láser de vanguardia para hiperplasia prostática benigna. Procedimiento mínimamente invasivo realizado por los mejores urólogos de Guadalajara.',
    features: [
      'Tecnología láser de alta precisión',
      'Procedimiento ambulatorio',
      'Mínimo sangrado y dolor',
      'Recuperación rápida (24-48 hrs)',
      'Sin necesidad de hospitalización prolongada'
    ],
    benefits: [
      'Mejora inmediata del flujo urinario',
      'Preservación de la función sexual',
      'Resultados duraderos',
      'Menor riesgo de complicaciones'
    ],
    image: 'https://readdy.ai/api/search-image?query=modern%20laser%20surgery%20equipment%20for%20prostate%20treatment%20in%20professional%20medical%20facility%2C%20advanced%20urological%20laser%20technology%20in%20clean%20medical%20room%2C%20high-tech%20medical%20device%20for%20prostate%20surgery%2C%20blue%20and%20white%20medical%20environment&width=600&height=400&seq=laser-prostata&orientation=landscape'
  },
  {
    id: 'calculos-urinarios',
    title: 'Cálculos Urinarios',
    icon: 'ri-drop-line',
    description: 'Tratamiento integral y mínimamente invasivo para cálculos renales y ureterales. UROMÁS Guadalajara cuenta con la tecnología más avanzada para fragmentación de piedras.',
    features: [
      'Litotricia extracorporal por ondas de choque',
      'Ureteroscopia flexible con láser',
      'Nefrolitotomía percutánea',
      'Análisis completo de composición',
      'Prevención de recurrencias'
    ],
    benefits: [
      'Eliminación completa de cálculos',
      'Procedimientos ambulatorios',
      'Mínimo dolor post-operatorio',
      'Recuperación rápida'
    ],
    image: 'https://readdy.ai/api/search-image?query=medical%20ultrasound%20equipment%20for%20kidney%20stone%20treatment%2C%20modern%20lithotripsy%20machine%20in%20professional%20urology%20clinic%2C%20advanced%20medical%20technology%20for%20urinary%20calculi%20treatment%2C%20clean%20medical%20facility%20interior&width=600&height=400&seq=calculos-urinarios&orientation=landscape'
  },
  {
    id: 'circuncision-laser',
    title: 'Circuncisión Láser',
    icon: 'ri-scissors-cut-line',
    description: 'Circuncisión con tecnología láser de alta precisión. Procedimiento seguro, rápido y con excelente resultado estético en UROMÁS Guadalajara.',
    features: [
      'Láser de alta precisión CO2',
      'Procedimiento de 20-30 minutos',
      'Anestesia local',
      'Sangrado mínimo',
      'Cicatrización optimizada'
    ],
    benefits: [
      'Excelente resultado estético',
      'Menor dolor post-operatorio',
      'Cicatrización más rápida',
      'Menor riesgo de infección'
    ],
    image: 'https://readdy.ai/api/search-image?query=precision%20laser%20medical%20equipment%20for%20minor%20surgical%20procedures%2C%20advanced%20medical%20laser%20technology%20in%20sterile%20operating%20room%2C%20modern%20urological%20surgery%20instruments%2C%20professional%20medical%20facility%20setup&width=600&height=400&seq=circuncision-laser&orientation=landscape'
  },
  {
    id: 'verrugas-genitales-ets',
    title: 'Verrugas Genitales y ETS',
    icon: 'ri-shield-check-line',
    description: 'Diagnóstico y tratamiento confidencial de verrugas genitales y enfermedades de transmisión sexual. Atención discreta y profesional en UROMÁS.',
    features: [
      'Consulta completamente confidencial',
      'Diagnóstico por PCR y cultivos',
      'Tratamiento con láser CO2',
      'Crioterapia selectiva',
      'Seguimiento médico especializado'
    ],
    benefits: [
      'Eliminación completa de lesiones',
      'Prevención de recurrencias',
      'Atención discreta y privada',
      'Resultados estéticamente superiores'
    ],
    image: 'https://readdy.ai/api/search-image?query=private%20medical%20consultation%20room%20with%20modern%20equipment%2C%20confidential%20medical%20examination%20setup%2C%20professional%20healthcare%20environment%20for%20sensitive%20treatments%2C%20clean%20and%20discrete%20medical%20facility%20interior&width=600&height=400&seq=verrugas-ets&orientation=landscape'
  },
  {
    id: 'engrosamiento-pene',
    title: 'Engrosamiento de Pene',
    icon: 'ri-male-line',
    description: 'Procedimientos estéticos discretos para aumentar el grosor del pene. Técnicas avanzadas realizadas por especialistas certificados en UROMÁS Guadalajara.',
    features: [
      'Consulta completamente privada',
      'Técnicas de injerto de grasa',
      'Materiales biocompatibles',
      'Procedimiento ambulatorio',
      'Seguimiento médico personalizado'
    ],
    benefits: [
      'Aumento natural del grosor',
      'Resultados permanentes',
      'Procedimiento seguro',
      'Máxima discreción'
    ],
    image: 'https://readdy.ai/api/search-image?query=private%20medical%20consultation%20room%20for%20aesthetic%20procedures%2C%20discrete%20medical%20facility%20interior%20with%20modern%20equipment%2C%20professional%20healthcare%20environment%20for%20cosmetic%20treatments%2C%20confidential%20medical%20setting&width=600&height=400&seq=engrosamiento-pene&orientation=landscape'
  },
  {
    id: 'disfuncion-erectil',
    title: 'Tratamiento para la Disfunción Eréctil',
    icon: 'ri-heart-pulse-line',
    description: 'Soluciones integrales para la disfunción eréctil. Desde tratamientos médicos hasta procedimientos avanzados con los mejores especialistas de Guadalajara.',
    features: [
      'Evaluación médica completa',
      'Tratamientos médicos avanzados',
      'Terapia con ondas de choque',
      'Implantes de prótesis de pene',
      'Inyecciones intracavernosas'
    ],
    benefits: [
      'Mejora significativa de la función sexual',
      'Tratamientos personalizados',
      'Resultados duraderos',
      'Atención completamente confidencial'
    ],
    image: 'https://readdy.ai/api/search-image?query=modern%20medical%20consultation%20room%20for%20mens%20health%20treatments%2C%20professional%20healthcare%20facility%20with%20advanced%20diagnostic%20equipment%2C%20confidential%20medical%20environment%20for%20sexual%20health%2C%20sophisticated%20medical%20interior&width=600&height=400&seq=disfuncion-erectil&orientation=landscape'
  }
];

export default function Procedures() {
  const [selectedProcedure, setSelectedProcedure] = useState<string | null>(null);

  const handleProcedureClick = (procedureId: string) => {
    setSelectedProcedure(selectedProcedure === procedureId ? null : procedureId);
  };

  return (
    <section id="procedimientos" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111317] mb-4">
            Procedimientos Especializados en UROMÁS Guadalajara
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-8">
            Centro Urológico líder en Guadalajara con los tratamientos más avanzados en urología masculina. 
            Tecnología láser de vanguardia y especialistas certificados para tu bienestar.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500">
            <span className="bg-blue-50 px-3 py-1 rounded-full">✨ Tecnología Láser Avanzada</span>
            <span className="bg-blue-50 px-3 py-1 rounded-full">🏥 Clínica Certificada en Guadalajara</span>
            <span className="bg-blue-50 px-3 py-1 rounded-full">👨‍⚕️ Urólogos Especialistas</span>
            <span className="bg-blue-50 px-3 py-1 rounded-full">🔒 Máxima Confidencialidad</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {procedures.map((procedure) => (
            <div key={procedure.id} className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100">
              <div className="p-6">
                {/* Eliminar la imagen del procedimiento */}

                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-[#1B84FF]/10 rounded-full flex items-center justify-center mr-4">
                    <i className={`${procedure.icon} text-xl text-[#1B84FF]`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#111317] leading-tight">
                    {procedure.title}
                  </h3>
                </div>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {procedure.description}
                </p>
                
                <button
                  onClick={() => handleProcedureClick(procedure.id)}
                  className="w-full bg-[#0B2A4A] text-white py-3 px-4 rounded-lg hover:bg-[#1B84FF] transition-colors cursor-pointer whitespace-nowrap font-medium flex items-center justify-center"
                >
                  <i className="ri-information-line mr-2"></i>
                  {selectedProcedure === procedure.id ? 'Ocultar detalles' : 'Ver detalles completos'}
                </button>
                
                {selectedProcedure === procedure.id && (
                  <div className="mt-6 space-y-4">
                    <div className="p-4 bg-blue-50 rounded-lg">
                      <h4 className="font-semibold text-[#0B2A4A] mb-3 flex items-center">
                        <i className="ri-settings-line mr-2"></i>
                        Características del Tratamiento
                      </h4>
                      <ul className="space-y-2">
                        {procedure.features.map((feature, index) => (
                          <li key={index} className="flex items-start text-sm text-gray-700">
                            <i className="ri-check-line text-[#1B84FF] mr-2 mt-0.5 flex-shrink-0"></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="p-4 bg-green-50 rounded-lg">
                      <h4 className="font-semibold text-[#0B2A4A] mb-3 flex items-center">
                        <i className="ri-heart-line mr-2"></i>
                        Beneficios para el Paciente
                      </h4>
                      <ul className="space-y-2">
                        {procedure.benefits.map((benefit, index) => (
                          <li key={index} className="flex items-start text-sm text-gray-700">
                            <i className="ri-star-line text-green-600 mr-2 mt-0.5 flex-shrink-0"></i>
                            {benefit}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="bg-gradient-to-r from-[#1B84FF] to-[#0B2A4A] text-white p-4 rounded-lg text-center">
                      <p className="text-sm mb-2">¿Necesitas este tratamiento?</p>
                      <a 
                        href="#contacto" 
                        className="inline-flex items-center bg-white text-[#1B84FF] px-4 py-2 rounded-lg font-medium text-sm hover:bg-gray-100 transition-colors cursor-pointer"
                      >
                        <i className="ri-calendar-line mr-2"></i>
                        Agendar Consulta
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Sección adicional para SEO */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">
              UROMÁS: Tu Clínica de Confianza en Guadalajara
            </h3>
            <p className="text-lg mb-6 opacity-90 max-w-3xl mx-auto">
              Más de 15 años siendo la clínica de urología de referencia en Guadalajara, Jalisco. 
              Nuestros especialistas Dr. Juan Pablo Delgadillo Espejo y Dr. Omar Martínez Soltero 
              te ofrecen los tratamientos más avanzados con tecnología láser de precisión.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">1500+</div>
                <div className="text-sm opacity-90">Procedimientos Realizados</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">98%</div>
                <div className="text-sm opacity-90">Pacientes Satisfechos</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2">25+</div>
                <div className="text-sm opacity-90">Procedimientos Especializados</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
